export enum PatientSegmentation {
  naive = 0,
  experienced = 1
}
